var Raphael = require('raphael'),
    BaseResize = require('./baseShapeResizeFns'),
    DummyRectBorder = require('../helper/dummyRectBorder.js');

// TODO: more sub-classing here (eg isRect) ...

module.exports = {

    resizeStart: function(x, y, e) {

        if ( !BaseResize.start.apply(this, arguments) )
            return;

        var dhCursor = this.dragHandle.attr('cursor'),
            noteSubType = this.channel.request('activeNoteSubType');

        this.isEast = dhCursor === 'se-resize' || dhCursor === 'ne-resize';
        this.isSouth = dhCursor === 'se-resize' || dhCursor === 'sw-resize';
        this.isRect = noteSubType.indexOf('rect') > -1;  //TODO: util fn --- perhaps isRect function?
        this.isText = noteSubType === 'text'; //TODO: util fn

        if ( this.isRect ) {
            /* ht and width can't be 0! -- otherwise NaN, Infinity in Matrix Calcs -- can occur if set on end resize (put there? */
            var box = this.el.getBBox(),
                ht = box.height,
                wt = box.width,
                noHt = ht === 0,
                noWt = wt === 0;

            if (noHt || noWt) {
                var np = Raphael.fn.rectPath(box.x, box.y, noWt ? wt + 1 : wt, noHt ? ht + 1 : ht);
                this.el.attr('path', np); //TODO: Raphael.parsePathString
            }

            this.dummyRectBorder = new DummyRectBorder(this.el);
        }

    },
    /* Resize -- this should now be used for drawRect and End Rect --- huh?? */
    resizeMove: function(dx, dy, x, y, e, onBeforeTransformEl ) {

        if ( !BaseResize.move.apply(this, arguments) ) return;

        // really only need the offset -- calc once on resize start -- ox + dx -- (do for optimization) ... ??
        var pos = this.parent.getMousePos( $.event.fix(e) ),  //!!must do for IE8 -- otherwise won't get page.X, page.Y props in get position
            mx = pos.x,
            my = pos.y,

            // why would I have put this here???
            doTriggers = function(box) {
                this.trigger('shape.resizeSelectBox', this.el.transform(), dx, dy);
                this.trigger('shape.resizeRect', box, dx, dy); // listened to by the individual shapes -- redaction, buttonSet, signature
            };

        // hook if provided: if returns false will exit the resize move 
        if (onBeforeTransformEl) {
            if (!onBeforeTransformEl.call(this, mx, my)) return;
        }

        // this is what changes the size of the shape
        this.el.setBoxTransformStr(mx, my, true, this.isEast, this.isSouth, this.proportionalResize);

        this.isRect && this.dummyRectBorder.move();

        doTriggers.call(this, this.el.getBBox() );
    },

    resizeEnd: function(e) {
        if ( !BaseResize.end.call(this, e) ) return;

        this.el.removeCachedBox();

        //TODO: add on before/after event ...
        if (this.isRect) {  //or TEXT too now?
            this.el.attr({
                path: this.el.getPathOfBBox(),
                transform: ''
            });
            this.dummyRectBorder.destroy(true); //true sets back the original stroke width, stroke

        } else { //free, textPath
            // checking for path is a quick fix for the graphic stamp, which is an image ... could later be more (?)
            this.el.isPath() && this.el.bakeTransform(1);
        }

        BaseResize.cleanUp.call(this);

        this.isEast = null;
        this.isSouth = null;
        this.isRect = null;
        this.isText = null;

    }


};




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/resizeFns/free.js
 ** module id = 193
 ** module chunks = 0
 **/